import axios from 'axios';
import React, {
  Component,
} from 'react';

import moment from 'moment';
var CREATE_BILL_PAYMENT = 'api/createBillPayment';
var ACCEPT_BILL_PAYMENT ='api/acceptBill?otpCode=';
var BILL_REGISTER = 'secured/savings/saveBillRegister';
var BILL_PAYMENT_TYPE = 'api/getBillPayType';
var GET_SERVICE_PROVIDER = 'api/getServiceProvider?billType=';
var GET_BILLING_ACCOUNT = 'api/getBillingAccount?billType=';
var REMOVE_BILL_RECIPIENT = 'api/removeBillRecipient?billId=';
var GET_BILL_PAYMENTS = 'api/getAllBillPayments';
var GET_BILL_DETAIL = 'api/getBillPaymentByPaymentId?paymentId=';
var api = require('./Config');
var CANCEL_BILL = 'secured/savings/suspendBillPaymentById'
var AMEND_BILL_PAYMENT = 'api/editBillPayment';
var GET_BILL_HISTORY = 'api/billPaymentHistory?';
var GET_BILL_HISTORY_TYPE = 'api/savingsBillPaymentHistoryByType?';
var GET_BILL_DETAILS_REF ='api/getActiveBillPaymentByBillRef?billRef=';
var FIXED_DEPOSITS = 'api/retriveFDSummary?idType=NIC&idNumber=';
var FD_LOANS = 'api/retriveFDLoans?status=';
var FD_LOANS_PAYMENTS = 'api/loanPayments?loanId=';
var FD_INFOR = 'api/retriveFixedDeposit?fdNumber=';
var GET_PAWNIGN_ITEM = 'api/retrivePawningTicketByTicketNo?ticketNo=';
var PAWNINGTICKET = 'api/retrivePawningByIdType?idType=NIC&idNumber=';


class CommonFDAPI extends React.Component{

  async BillPaymentType(returnVal) {    
      return await axios({
        method: "GET",
        url:api.HOST+BILL_PAYMENT_TYPE,            
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then((result) => {          
            return returnVal(result.data); 
      }).catch((error)=> {
            return returnVal(error.response);
            console.log(error);
      });      
 }

 async GetServiceProviderForReg(pl,returnVal) {
 
    return await axios({
     method: "GET",
      url:api.HOST+GET_SERVICE_PROVIDER+pl.type,            
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {      
        return returnVal(result.data);
    }).catch ((err)=>{
      return returnVal(err.response);
    });    
}
async GetExistBillRecipient(pl,returnVal) {
 
  return await axios({
   method: "GET",
    url:api.HOST+GET_BILLING_ACCOUNT+pl.type,            
    headers: {
      'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  .then((result) => {      
      return returnVal(result.data);
  }).catch ((err)=>{
    return returnVal(err.response);
  });    
}
async CreateBillPayment(pl,returnVal) {
    return await axios({
      method: "POST",
      url:api.HOST+CREATE_BILL_PAYMENT,           
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
            "dueDate":pl.DueDate,
            "endDate":pl.EndDate,
            "provider":pl.ServiceProviderName,
            "providerCode":pl.ServiceProviderCode,
            "payAmount":pl.ExistEnteredAmount,
            "accountNo":pl.SavingsAccountNum,
            "billingAccount":pl.BillingAccNum,
            "frequency":pl.SelectedFrequency,
            "recurringPay":pl.CheckRecurring,
            "otpReference":pl.OtpReference,
            "beneReference":pl.BillBeneRef,
            "bankReference": pl.BillYourRef,
            "deviceType": "WEB"
          }),
        })
        .then((result) => {            
            return returnVal(result.data);
        }).catch((error)=> {
          return returnVal(error.response);
          console.log(error);
      });      
  }
async AcceptBillPayment(pl,returnVal) {   
      return await axios({
        method: "GET",
        url:api.HOST+ACCEPT_BILL_PAYMENT+pl.EnteredOTP+'&deviceType='+'WEB',               
        headers: {
          'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {        
          return returnVal(result.data);
      }).catch((error)=> {
        return returnVal(error.response);
        console.log(error);
    })    
  }


async RemoveBillRecipient(pl,returnVal) {
 
  return await axios({
   method: "GET",
    url:api.HOST+REMOVE_BILL_RECIPIENT +pl.BillingId,            
    headers: {
      'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  .then((result) => {      
      return returnVal(result.data);
  }).catch ((err)=>{
    return returnVal(err.response);
  });    
}
async ActiveBillPayments(returnVal) {
    return await axios({
      method: "GET",
      url:api.HOST+GET_BILL_PAYMENTS,       
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {       
        return returnVal(result.data);
    }).catch((error)=> {
      console.log(error);
      return returnVal(error.response);
  });  
}

async CheckPasswordToReg(pl,returnVal) {
 
    return await axios({
      method: "POST",
      url:api.HOST+BILL_REGISTER,           
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      },
      data:JSON.stringify({
          "type" : pl.BillRegisterType,
          "provider" :pl.RegServiceProviderCode,
          "cardNo" : pl.Bill_Acc,
          "password" : pl.BillRegPassword,
          "userId" : JSON.parse(sessionStorage.getItem("userId")).id,
        }),
    })
    .then((result) => {   
        return returnVal(result.data);
    }).catch((error)=> {
      return returnVal(error.response.data);      
  });  
}

async ActiveBillDetails(pl,returnVal) {
 
    return await axios({
      method: "GET",
      url:api.HOST+GET_BILL_DETAIL+pl.BillId,           
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {       
        return returnVal(result.data);
    }).catch ((err)=>{
      return returnVal(err.response);
      console.log(err);
    });  
}
async SuspendBill(pl,returnVal) {
  
    return await axios({
      method: "POST",
      url:api.HOST+CANCEL_BILL,          
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      },
      data:JSON.stringify({
          "id" : pl.BillId,
          "password" : pl.BillPassword,
          "userId" :JSON.parse(sessionStorage.getItem("userId")).id, 
        }),
    })
    .then((result) => {      
        return returnVal(result.data);
    }).catch((error)=> {
      return returnVal(error.response);
      console.log(error);      
  });  
}

async AmmendBill(pl,returnVal){
    return await axios({
      method: "POST",
      url:api.HOST+AMEND_BILL_PAYMENT,         
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
                  "id":pl.BillID,
                  "payAmount": pl.Amount,
                  "frequency": pl.SelectedFrequency,
                  "endDate": pl.PayEnd,
                  "dueDate": pl.scheduleDate,
                  "recurringPay": pl.CheckRecurring,
                  "bankReference": pl.YourReference,
                }),
    })
    .then((result) => {
        return returnVal(result.data);
    }).catch ((err)=>{
      console.log(err);
      return returnVal(err.response);
    });  
}

async GetBillHistory(pl,returnVal) {
  
     if((!pl.RegServiceProviderCode&&!pl.BillRegisterType)||pl.RegServiceProviderCode){
     return await axios({
       method: "GET",
       url:api.HOST+GET_BILL_HISTORY+pl.WithPara,          
       headers: {
         'Authorization' :`bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
       }
     })
     .then((result) => {      
         return returnVal(result.data);
     }).catch ((err)=>{
      return returnVal(err.response);
       console.log(err);      
     });
   }else if(pl.BillRegisterType&&!pl.RegServiceProviderCode){
     return await axios({
       method: "GET",
       url:api.HOST+GET_BILL_HISTORY_TYPE+pl.WithTypePara ,          
       headers: {
         'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
       }
     })
     .then((result) => {
      return returnVal(result.data);
     }).catch ((err)=>{
      return returnVal(err.response);
     });
    }   
}

async BillHistoryDetails(pl,returnVal) {

    return await axios({
      method: "GET",
      url:api.HOST+GET_BILL_DETAILS_REF+pl.Billrefz,
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then((result) => {
      return returnVal(result.data);
    }).catch ((err)=>{
      return returnVal(err.response);
    });  
}

async FixedDeposits(returnVal) { 
        
    return await axios({
      url:api.HOST+FIXED_DEPOSITS+JSON.parse(sessionStorage.getItem("NIC")).IdOfUser,
      method: "GET",
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type' : 'application/json'
      }
    })
    .then((result) => {
      return returnVal(result.data);
    }).catch((error)=> {
      return returnVal(error.response);
  });  
}

async FDLoansAPI(pl,returnVal) {

    return await axios({
      method: "GET",
      url:api.HOST+FD_LOANS+pl.Status+"&loanAmountSlab="+pl.Amount+"&fromDate="+pl.FromDate+"&toDate="+pl.ToDate, 
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      }
    })
    .then((result) => {       
        return returnVal(result.data);
    }).catch((error)=> {
      return returnVal(error.response);
  });  
}

async GetFDLoansPayments(returnVal) {
 
    return await axios({
      method: "GET",
      url : api.HOST+FD_LOANS_PAYMENTS+JSON.parse(sessionStorage.getItem("fdValue")).id,               
      headers: {
        'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
        'Content-Type': 'application/json'
      }
    }).then((result) => {
        return returnVal(result.data);
      }).catch((error)=> {
        return returnVal(error.response);
    });
}

async GetFDMoreInfo(returnVal) {  
  var Fdnum  =  JSON.parse(sessionStorage.getItem("fdValue")).fdNumber;
  return await axios({
    method: "GET",
    url : api.HOST+FD_INFOR+Fdnum+'&idType=NIC&idNumber='+JSON.parse(sessionStorage.getItem("NIC")).IdOfUser,               
    headers: {
      'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/json'
    }
  }).then((result) => {
      return returnVal(result.data);
    }).catch((error)=> {
      return returnVal(error.response);
  });
}
async GetPawnignTicket(returnVal) { 
  return await axios({
    method: "GET",
    url:api.HOST+PAWNINGTICKET+JSON.parse(sessionStorage.getItem("NIC")).IdOfUser,              
    headers: {
      'Authorization' :  `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  .then((result) => {
      return returnVal(result.data);
    }).catch((error)=> {
      console.log(error);
      return returnVal(error.response);
  });
}

async GetPawnignItems(pl,returnVal) { 
  return await axios({
    method: "GET",
    url:api.HOST+GET_PAWNIGN_ITEM+pl.ticketnumber+'&idType=NIC&idNumber='+JSON.parse(sessionStorage.getItem("NIC")).IdOfUser,               
    headers: {
      'Authorization' :  `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  .then((result) => {
      return returnVal(result.data);
    }).catch((error)=> {
      console.log(error);
      return returnVal(error.response);
  });
}

}

export default new CommonFDAPI();